export default __webpack_public_path__ + "static/image1-053a909e32c647bfdb9390c146a2bb13.png";